export const projectCreatedPageOptions = [
  {
    label: '首页',
    value: 'index',
  },
  {
    label: '模板列表',
    value: 'template',
  },
  {
    label: '个人模板',
    value: 'person-template',
  },
  {
    label: '项目列表',
    value: 'list',
  },
  {
    label: '制作页',
    value: 'editing',
  },
]
